/**
 * Los pasos del asistente de Reactivación (`/activa/real`), por nombre, y la migración del número de paso
 * de un borrador guardado. Vive aparte de la página para poder probarla sin montarla.
 */

/**
 * Índices por NOMBRE. El wizard tenía los números a mano en 20 lugares (`current === 4`,
 * `go(5)`, `case 6:`): insertar un paso en el medio obligaba a correr todos y bastaba errar
 * uno para mandar al operador al paso equivocado. El orden vive acá y en un solo lado.
 */
export const P = {
  carga: 0, mapeo: 1, reporte: 2,
  tono: 3, oferta: 4, cuando: 5,      // el contexto, en tres decisiones
  plan: 6, mensajes: 7,
  canales: 8,                  // WhatsApp y/o email, según lo elegido
  envio: 9,
  resultados: 10,              // con las respuestas adentro
} as const;

/**
 * La versión de la numeración de los pasos. El borrador guarda `current` y `maxReached` como números:
 * cuando los pasos cambian, un borrador viejo abriría corrido (en «Envío» un borrador que estaba en
 * «Conectar»). v1 tenía 13 pasos (canalWa 8, canalEmail 9, envio 10, resultados 11, respuestas 12).
 */
export const VERSION_PASOS = 2;
export function migrarPaso(i: unknown, version: unknown): number {
  const n = Number.isInteger(i) ? (i as number) : 0;
  if (version === VERSION_PASOS) return Math.min(Math.max(n, 0), P.resultados);
  // v1 → v2: 0..8 quedan; canalEmail (9) era otra pantalla de «Conectar»; envío y resultados bajan uno o dos.
  const v1: Record<number, number> = { 9: P.canales, 10: P.envio, 11: P.resultados, 12: P.resultados };
  return Math.min(Math.max(v1[n] ?? n, 0), P.resultados);
}
